import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Form, NgForm } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-document-upload-modal',
  templateUrl: './document-upload-modal.component.html',
  styleUrls: ['./document-upload-modal.component.scss']
})
export class DocumentUploadModalComponent implements OnInit {

  files: File[] = [];
  @ViewChild('documentModal') documentModal;
  @Output() submit: EventEmitter<FormData> = new EventEmitter<FormData>();

  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
  }

  // handle the popup
  open() {
    this.modalRef = this.modalService.open(this.documentModal, { centered: true, size: 'lg' });
  }

  close() {
    this.files = [];
    this.modalRef.close();
  }

  // handle file uploading
  onSelect(event) {
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
  }

  onSubmit(f: ElementRef) {
    let formData = new FormData();
    this.files.forEach((val, index, arr) => {
      formData.append('document', val);
    });

    this.submit.emit(formData);
  }

}
